export const MEDIA_SIZE_XXSMALL = 'xxs';
export const MEDIA_SIZE_XSMALL = 'xs';
export const MEDIA_SIZE_SMALL = 's';
export const MEDIA_SIZE_MEDIUM = 'm';
export const MEDIA_SIZE_LARGE = 'l';
export const MEDIA_SIZE_FULL = 'full';
